module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/how_to_enjoy_photography_case2-139665962f5925b212dbd3f29509dc34.png";